<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-cleverty print:hidden" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-8" src="assets/images/logo/logo.svg" />
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <notifications></notifications>
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4">
            <div class="relative w-24 h-24">
                @if (user?.profile_pic) {
                    <img class="w-full h-full rounded-full" [src]="'https://cloud.cleverty.app/' + user?.profile_pic" alt="User avatar" />
                }
                @if (!user?.profile_pic) {
                    <mat-icon class="icon-size-24" fontSet="fa" fontIcon="fa-user-circle"></mat-icon>
                }
            </div>
            <div class="flex flex-col items-center justify-center w-full mt-6">
                <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">{{ user?.firstname }} {{ user?.lastname }}</div>
                <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{ user?.email }}
                </div>
                <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">Version: {{ adminVersion }}</div>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.svg" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon fontSet="fa" fontIcon="fa-bars"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- COMBOBOX PARA EMPRESAS -->
            @if (companies.length > 1) {
                <mat-form-field class="header-combobox-companies">
                    <input
                        matInput
                        placeholder="{{ 'SELECT.Selected_company' | transloco }}"
                        [matAutocomplete]="autoCompany"
                        [formControl]="searchCompaniesCtrl"
                        (focus)="clearSearchInput('company')" />
                    <mat-autocomplete #autoCompany="matAutocomplete" [displayWith]="getDisplayFn()" (optionSelected)="setCompany($event.option.value)">
                        @for (item of (filteredCompany | async) || []; track item) {
                            <mat-option [value]="item">
                                <span>
                                    <b>{{ item?.name }}</b>
                                </span>
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            }

            <!-- COMBOBOX PARA COMUNIDADES -->
            @if (communities.length > 1) {
                <mat-form-field class="header-combobox-communities">
                    <input
                        matInput
                        placeholder="{{ 'SELECT.Selected_community' | transloco }}"
                        [matAutocomplete]="autoCommunity"
                        [formControl]="searchCommunitiesCtrl"
                        (focus)="clearSearchInput('community')" />
                    <mat-autocomplete #autoCommunity="matAutocomplete" [displayWith]="getDisplayFn()" (optionSelected)="setCommunity($event.option.value)">
                        @for (item of (filteredCommunity | async) || []; track item) {
                            <mat-option [value]="item">
                                <span>
                                    <b>{{ item?.name }}</b>
                                </span>
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            }

            <languages></languages>

            <!-- <button mat-icon-button (click)="openCreateTicketModal()"><mat-icon fontSet="fa" fontIcon="fa-headset"></mat-icon></button> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <messages></messages>

            <!-- <button [hidden]="!('contacts' | profile: 'contacts_chats')" class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
      <mat-icon fontSet="fa" fontIcon="fa-comments"></mat-icon>
    </button> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->

    <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
<span class="font-medium text-secondary">Cleverty &copy; {{currentYear}}</span>
</div> -->
</div>

<!-- Quick chat -->
<!-- <div [hidden]="!('contacts' | profile: 'contacts_chats')">
<quick-chat #quickChat="quickChat"></quick-chat>
</div> -->
